export default {
  organizations_title: 'Suspensión de licencias',
  organizations_subtitle: 'Elige una organización para ver sus unidades de negocio.',
  report_nav_button: 'Reporte de licencias',
  franchises_subtitle: 'Elige una unidad de negocio para ver sus usuarios.',
  users_subtitle: 'Activa o suspende la licencia de cada usuario.',

  column_logo: 'Logo',
  column_photo: 'Foto',
  column_id: 'ID',
  column_organization: 'Organización',
  column_franchise: 'Unidad de negocio',
  column_franchises_count: 'Unidades de negocio',
  column_licenses: 'Licencias',
  column_active: 'Activas',
  column_suspended: 'Suspendidas',
  column_status: 'Estatus',
  column_is_unused: 'Inutilizada',
  column_actions: 'Acciones',
  column_first_name: 'Nombre',
  column_last_name: 'Apellido',
  column_email: 'Correo',
  column_license: 'Licencia',
  column_license_type: 'Tipo de licencia',
  column_assigned_at: 'Fecha de asignación',

  status_active: 'Activa',
  status_suspended: 'Suspendida',
  is_unused_yes: 'Inutilizada',
  is_unused_no: 'En uso',
  organization_status_active: 'Activa',
  organization_status_inactive: 'Inactiva',
  organization_status_demo: 'Demo',

  filter_status: 'Estatus',
  filter_all_statuses: 'Todos los estatus',

  no_organizations: 'No hay organizaciones que coincidan con la búsqueda.',
  no_franchises: 'Esta organización no tiene unidades de negocio.',
  no_users: 'No hay usuarios que coincidan con los filtros.',

  suspend_all: 'Suspender todas',
  reactivate_all: 'Reactivar todas',
  bulk_suspend: 'Suspender licencias',
  bulk_reactivate: 'Reactivar licencias',
  clear_selection: 'Limpiar selección',
  selected_count: 'Seleccionados: {count}',
  selected_licenses: '{count} licencia(s) en el alcance seleccionado',
  scope_organizations: '{count} organizaciones',
  scope_franchises: '{count} unidades de negocio',

  confirm_suspend_title: 'Suspender licencias',
  confirm_reactivate_title: 'Reactivar licencias',
  confirm_suspend_organization: 'Estás por suspender {count} licencia(s) de {scope}. Afecta a TODOS los usuarios, en todas sus unidades de negocio.',
  confirm_reactivate_organization: 'Estás por reactivar {count} licencia(s) de {scope}. '
    + 'Afecta a TODOS los usuarios, en todas sus unidades de negocio.',
  confirm_suspend_franchise: 'Estás por suspender {count} licencia(s) de {scope}. Afecta a TODOS los usuarios de esa unidad de negocio.',
  confirm_reactivate_franchise: 'Estás por reactivar {count} licencia(s) de {scope}. Afecta a TODOS los usuarios de esa unidad de negocio.',
  confirm_suspend_users: 'Estás por suspender {count} licencia(s) de {scope}.',
  confirm_reactivate_users: 'Estás por reactivar {count} licencia(s) de {scope}.',
  confirm_suspend_user: '¿Deseas suspender la licencia de {email}?',
  confirm_reactivate_user: '¿Deseas reactivar la licencia de {email}?',
  confirm_ok: 'Confirmar',
  confirm_cancel: 'Cancelar',

  reason_label: 'Razón',
  reason_detail_label: 'Detalle (opcional)',
  reason_detail_label_required: 'Detalle',
  reason_detail_hint: 'Máximo 2000 caracteres',

  reason_invoice_overdue: 'Factura vencida',
  reason_contract_termination: 'Terminación de contrato',
  reason_trial: 'Fin de periodo de prueba',
  reason_temporary_reactivation: 'Reactivación temporal',
  reason_payment_success: 'Pago recibido',
  reason_other: 'Otros',

  notify_suspended: 'Licencia suspendida',
  notify_reactivated: 'Licencia reactivada',
  notify_bulk_suspended: 'Se suspendieron {count} licencia(s)',
  notify_bulk_reactivated: 'Se reactivaron {count} licencia(s)',
  notify_no_changes: 'Sin cambios: las licencias ya estaban en ese estado',
  notify_load_error: 'No se pudo cargar la información',
  notify_error: 'No se pudo actualizar la licencia',
  error_reason_invalid: 'La razón elegida no corresponde al movimiento. Vuelve a intentarlo.',

  report_title: 'Reporte de licencias',
  report_subtitle: 'Genera una exportación de licencias filtrada por organización, unidad de negocio, tipo y fecha de asignación.',
  report_filter_organization: 'Organización',
  report_filter_franchise: 'Unidad de negocio',
  report_filter_franchise_all: 'Todas las unidades de negocio',
  report_filter_type: 'Tipo de licencia',
  report_filter_type_all: 'Todos los tipos',
  report_filter_type_individual: 'Individual',
  report_filter_type_franchise: 'Sucursal',
  report_filter_assigned_from: 'Fecha de asignación desde',
  report_filter_assigned_to: 'Fecha de asignación hasta',
  report_download: 'Descargar reporte',
  report_download_pdf: 'Descargar PDF',
  report_export_starting: 'La exportación ha comenzado. Te avisaremos en el panel de notificaciones cuando esté lista.',
  report_export_error: 'Error al solicitar la exportación. Intenta de nuevo.',
  report_preview_title: 'Vista previa',
  report_preview_hint: 'Selecciona una organización para ver una vista previa de las licencias.',

  kpi_dashboard_title: 'Resumen',
  kpi_total: 'Licencias totales',
  kpi_active: 'Activas',
  kpi_active_percent: '{percent}% activo',
  kpi_suspended: 'Suspendidas',
  kpi_subutilized: 'Inutilizadas',
  kpi_subutilized_tooltip: 'Sin conexión > {days} días',
  kpi_demo: 'Demo',
  kpi_demo_usage: '{used} / {quota}',
  kpi_demo_no_quota: 'Sin cupo demo configurado',
  kpi_demo_percent: '{percent}% usado',
  kpi_standard: 'Estándar',
  kpi_chart_title: 'Composición de licencias',
  kpi_chart_active: 'Activas',
  kpi_chart_suspended: 'Suspendidas',
  kpi_chart_subutilized: 'Inutilizadas',

  global_kpi_title: 'Totales de la plataforma',
  global_kpi_sync: 'Sincronizar',
  global_kpi_updated_at: 'Actualizado {time}',
  global_kpi_sync_error: 'No se pudo sincronizar los totales. Intenta de nuevo.'
}
